module.exports = __webpack_public_path__ + "img/2.87b21897.png";